/**
 * Shared constants for mentor profile options.
 * Used by MentorProfileForm (editing), MentorCard, and MentorDirectory (display).
 *
 * `preferredAudience` is NOT here: it is a per-tenant taxonomy dimension
 * (`useEcosystemTaxonomy().mentorAudiences`), not a fixed platform enum.
 * `availableFor` stays a fixed platform-wide enum.
 */

export const AVAILABLE_FOR_OPTIONS = [
    { value: 'one-on-one', label: 'One-on-One Mentoring' },
    { value: 'group', label: 'Group Mentoring' },
    { value: 'speaking', label: 'Speaking / Presentations' },
    { value: 'career-advice', label: 'Career Advice' },
    { value: 'project-guidance', label: 'Project Guidance' },
    { value: 'networking', label: 'Networking Introductions' },
];

/**
 * Look up the human-readable label for an availableFor enum value.
 */
export const getAvailableForLabel = (value) =>
    AVAILABLE_FOR_OPTIONS.find((o) => o.value === value)?.label || value;
